import { Product } from 'Interfaces/Interfaces';
import { get } from 'lodash';

const root = (state: object) => get(state, 'alaCarteState');

export const getProducts = (state: object): { [key: string]: Product } => get(root(state), 'products');
